<!--
This component generates the invites list group for the specified {{status}.
Receiver must pass an array to {inviteData} to let the component generate the proper ui.
-->
<template>
  <section class="invite-section">
    <div class="list-group-container">
      <div class="d-flex flex-row list-row-header">
        <div class="p-2 w-50">Name</div>
        <div class="p-2 w-25">Check-in</div>
        <div class="p-2 w-25">Check-out</div>
      </div>

      <!--Appears if there's no scans-->
      <div class="d-flex flex-row list-row-empty" v-if="!hasScans">
        <div class="flex-fill">No log/s yet.</div>
      </div>
      <!--end no scans-->

      <!-- appears if with scans/s -->
      <div class="list-rows" v-else>
        <div v-for="(data, index) in scans" :key="index" class="d-flex flex-row list-row">
          <div class="px-2 w-50 list-column-item">{{ data.individual_name }}</div>
          <div class="px-2 w-25 list-column-item">
            <div class="flex-row list-row"
              v-for="(date, index) in data.check_in_dates"
              :key="index">
              {{ convertEpochTime(date) }}
            </div>
          </div>
          <div class="px-2 w-25 list-column-item">
            <div class="flex-row list-row"
              v-for="(scannedAction, index) in data.check_out_dates"
              :key="index">
              {{ convertEpochTime(scannedAction) }}
            </div>
          </div>
        </div>
      </div>
      <!-- end with scans -->
    </div>
    <!--end list group-->
  </section>
</template>

<script>
import '@/assets/styles/list-style.css'

export default {
  name: 'scans-list-view',
  data() {
    return {}
  },
  props: {
    scans: Array,
    hasScans: Boolean,
    convertEpochTime: Function
  }
}
</script>

<style scoped>
.invite-section {
  margin-top: 48px;
}
.invite-status-header {
  display:flex;
  align-items: center;
}
.invite-status-title {
  font-family: "HKGrotesk-Bold", Helvetica, sans-serif;
  color: #00386A;
  font-size: 20px;
}
.invite-status-indicator {
  width: 12px;
  height: 12px;

  border-radius: 100%;
  margin-right: 12px;
}

/* Status indicator color styles */
.status-active {
  background-color: #42BB79;
}
.status-inactive {
  background-color: #547181;
}
.status-pending {
  background-color: #EDC834;
}
</style>



// WEBPACK FOOTER //
// src/components/listview/ScansListView.vue